import { Button, Drawer, Col, Form, Radio, Typography, Select, Slider } from 'antd';
import React, { useState, useRef } from 'react';
import { ResetIcon } from '../../../assets/icons/general/reset';
import ApiSelect from '../../../components/api-select/api-select';
import { MASTER_DATA_FIELD } from '../../../constants/masterData';
import { useDispatch, useSelector } from 'react-redux';
import { changeModel, masterDataDropDownList, profileState } from '../../profile/profile.slice';
import { CANDIDATE_STATUS } from './candidate-status-tab-list';
import { applyFilter } from '../store/candidate.slice';
const { Text } = Typography;

const FilterDrawer = ({ visible, onClose }) => {
    const [searchValue, setSearchValue] = useState('');
    const [page, setPage] = useState(0);
    const [status, setStatus] = useState('loading');
    const [experienceRange, setExperienceRange] = useState([]);
    const formRef = useRef(null);

    const dispatch = useDispatch();
    const { masterDataDropDown, isNext } = useSelector(profileState);

    const fetchOptions = async (search = "", pageNumber = 1, model) => {
        setStatus("loading");
        setSearchValue(search);

        try {
            dispatch(changeModel(model))
            const result = await dispatch(
                masterDataDropDownList({
                    search: search,
                    id: model,
                    skip: pageNumber
                })
            ).unwrap();

            const newData = Array.isArray(result?.data) ? result.data : [];


            setPage(pageNumber + 1);
            setStatus(newData.length === 0 ? "noData" : "loaded");
        } catch (error) {
            console.error("Dropdown fetch failed", error);
            setStatus("noData");
        }
    };

    const resetFilters = () => {
        formRef.current.resetFields();
        setExperienceRange([])
        setSearchValue('');
        setPage(0);
        setStatus('loading');
        // dispatch(getAllCandidate({ filter: {} }))
    };



    const handleApply = () => {
        const formValues = formRef.current.getFieldsValue(); // Get all form values
        dispatch(applyFilter(formValues))
        // console.log("Form Values: ", formValues);

        // console.log('Apply Filters:', formRef.current.getFieldsValue());

        onClose();
    };

    const generateSliderMarks = (min, max, step) => {
        const marks = {};
        for (let i = min; i <= max; i += step) {
            const isVisible = i % 5 === 0;
            if (isVisible) {
                const label = Number.isInteger(i) ? `${i}` : `${i.toFixed(1)}`;
                marks[parseFloat(i.toFixed(1))] = label;
            }
        }
        return marks;
    };

    return (
        <Drawer
            title={
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text strong>Filter Options</Text>

                    <Button
                        icon={<ResetIcon width={25} />}
                        onClick={resetFilters}
                        type="text"
                        style={{ padding: 0 }}
                    />
                </div>
            }
            footer={
                <div style={{ textAlign: 'right', padding: '8px 4px' }}>
                    <Button
                        onClick={() => { onClose(); resetFilters() }}
                        style={{ marginRight: "10px", color: "#000", backgroundColor: "transparent", border: "1px solid #d9d9d9" }}
                        color="default" variant="outlined"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleApply}
                    >
                        Apply
                    </Button>
                </div>
            }
            placement="right"
            width={400}
            onClose={() => { onClose(); resetFilters() }}
            closeIcon={false}
            visible={visible}
            styles={{
                body: {
                    padding: '14px 24px',
                },
                content: {
                    height: '100vh',
                },
                wrapper: {
                    minHeight: '100vh',
                },
            }}
        >
            <Form
                layout="vertical"
                name="filterForm"
                ref={formRef}  // Assign the ref to the Form to control the reset and get values
                labelCol={{ style: { padding: '0 0 3px' } }}
            >
                {/* Gender Filter */}
                <Col span={24}>
                    <Form.Item label="Gender" name="gender">
                        <Radio.Group
                            style={{ width: '100%' }}
                        >
                            <Radio value="male">Male</Radio>
                            <Radio value="female">Female</Radio>
                            {/* <Radio value="Other">Other</Radio> */}
                        </Radio.Group>
                    </Form.Item>
                </Col>

                {/* Status Filter */}
                <Col span={24} style={{ marginTop: 16 }}>
                    <Form.Item label="Status" name="status">
                        <Select
                            style={{ width: '100%' }}
                            placeholder={"Select Status"}
                        >
                            {CANDIDATE_STATUS.map((status) => (
                                <Select.Option key={status.value} value={status.value}>
                                    {status.label}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>

                {/* Employment Type API Select */}
                <Col className='' span={24} style={{ marginTop: 16 }}>
                    <ApiSelect

                        label="Employment Type"
                        name={MASTER_DATA_FIELD.employmentType}
                        placeholder="Search Employment Type"
                        onClick={() => fetchOptions('', 0, MASTER_DATA_FIELD.employmentType)}
                        onSearch={(value) => fetchOptions(value, 0, MASTER_DATA_FIELD.employmentType)}
                        onScrollBottom={() => fetchOptions(searchValue, page, MASTER_DATA_FIELD.employmentType)}
                        options={masterDataDropDown?.employmentType}
                        dropdownStatus={status}
                        isNext={isNext}
                        allowClear
                        disabled={false}
                        // className="filter_selector"
                        mode="multiple"
                    />
                </Col>

                {/* Institute API Select */}
                <Col span={24} style={{ marginTop: 16 }}>
                    <ApiSelect
                        label="Institute"
                        name={MASTER_DATA_FIELD.institute}
                        placeholder="Search Institute"
                        onClick={() => fetchOptions('', 0, MASTER_DATA_FIELD.institute)}
                        onSearch={(value) => fetchOptions(value, 0, MASTER_DATA_FIELD.institute)}
                        onScrollBottom={() => fetchOptions(searchValue, page, MASTER_DATA_FIELD.institute)}
                        options={masterDataDropDown?.institute}
                        dropdownStatus={status}
                        isNext={isNext}
                        allowClear
                        disabled={false}
                        className="filter_selector"
                        mode="multiple"
                    />
                </Col>

                {/* Degree API Select */}
                <Col span={24} style={{ marginTop: 16 }}>
                    <ApiSelect
                        label="Degree"
                        name={MASTER_DATA_FIELD.degree}
                        placeholder="Search Degree"
                        onClick={() => fetchOptions('', 0, MASTER_DATA_FIELD.degree)}
                        onSearch={(value) => fetchOptions(value, 0, MASTER_DATA_FIELD.degree)}
                        onScrollBottom={() => fetchOptions(searchValue, page, MASTER_DATA_FIELD.degree)}
                        options={masterDataDropDown?.degree}
                        dropdownStatus={status}
                        isNext={isNext}
                        allowClear
                        disabled={false}
                        className="filter_selector"
                        mode="multiple"
                    />
                </Col>

                {/* Company API Select */}
                <Col span={24} style={{ marginTop: 16 }}>
                    <ApiSelect
                        label="Company"
                        name={MASTER_DATA_FIELD.company}
                        placeholder="Search Company"
                        onClick={() => fetchOptions('', 0, MASTER_DATA_FIELD.company)}
                        onSearch={(value) => fetchOptions(value, 0, MASTER_DATA_FIELD.company)}
                        onScrollBottom={() => fetchOptions(searchValue, page, MASTER_DATA_FIELD.company)}
                        options={masterDataDropDown?.company}
                        dropdownStatus={status}
                        isNext={isNext}
                        allowClear
                        disabled={false}
                        // className="filter_selector"
                        mode="multiple"
                        className="custom-multiselect"
                    />
                </Col>
                <Col span={24} style={{ marginTop: 16 }}>
                    <ApiSelect
                        label="Designation"
                        name={MASTER_DATA_FIELD.designation}
                        placeholder="Search Company"
                        onClick={() => fetchOptions('', 0, MASTER_DATA_FIELD.designation)}
                        onSearch={(value) => fetchOptions(value, 0, MASTER_DATA_FIELD.designation)}
                        onScrollBottom={() => fetchOptions(searchValue, page, MASTER_DATA_FIELD.designation)}
                        options={masterDataDropDown?.designation}
                        dropdownStatus={status}
                        isNext={isNext}
                        allowClear
                        disabled={false}
                        // className="filter_selector"
                        mode="multiple"
                        className="custom-multiselect"
                    />
                </Col>
                <Col span={24} style={{ marginTop: 16 }}>
                    <Form.Item
                        label={
                            experienceRange.length === 2 && (experienceRange[0] > 0 || experienceRange[1] > 0)
                                ? experienceRange[0] === experienceRange[1]
                                    ? `Experience (${experienceRange[0]} Years)`
                                    : `Experience (${experienceRange[0]} - ${experienceRange[1]} Years)`
                                : 'Experience'
                        }
                        name="experienceRange"
                    >
                        <Slider
                            range
                            step={0.5}
                            min={0}
                            max={20}
                            tooltip={{ formatter: value => `${value} yrs` }}
                            marks={generateSliderMarks(0, 20, 0.5)}
                            onChange={(value) => setExperienceRange(value)}
                        />
                    </Form.Item>
                </Col>
            </Form>
        </Drawer>
    );
};

export default FilterDrawer;
